function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { StyleSheet } from 'react-native';
import React from 'react';
import { ScrollView, View } from "../../../native";
import { useForwardRef } from "../../../../hooks";
import * as R from 'unitx/ramda';
import wrapComponent from "../../../../core/wrapComponent";
import Widgets from "../Widgets";
import Fields from "../Fields";
import Templates from "../Templates";
import ErrorList from "../ErrorList";
import ActionButtons from "../ActionButtons";
import FormNative from "./default";
const MockHTMLForm = wrapComponent((props, forwardedRef) => {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(ScrollView // @ts-ignore
  , {
    ref: () => forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef({
      dispatchEvent: () => {}
    }),
    style: styles.container
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, children));
}, {
  isForwardRef: true
});
const styles = StyleSheet.create({
  container: {// paddingHorizontal: 5,
  }
});

function FormElement(props, forwardedRef) {
  const {
    fields,
    widgets,
    children,
    onSubmit,
    formContext,
    formData,
    onChange,
    defaultSubmitEnabled,
    schema,
    uiSchema,
    extraData,
    Container = View
  } = props,
        directProps = _objectWithoutProperties(props, ["fields", "widgets", "children", "onSubmit", "formContext", "formData", "onChange", "defaultSubmitEnabled", "schema", "uiSchema", "extraData", "Container"]);

  const [state, setState] = React.useState({
    key: 0,
    schema,
    initialValue: formData,
    uiSchema,
    extraData
  });
  const form = useForwardRef(forwardedRef, {}, () => ({
    clear: () => setState(_objectSpread(_objectSpread({}, state), {}, {
      key: state.key + 1
    }))
  }));
  React.useEffect(() => {
    const isExtraDataChanged = R.complement(R.equals(state.extraData))(extraData);

    const clearForm = () => setState({
      key: state.key + 1,
      extraData,
      schema,
      uiSchema,
      initialValue: formData
    });

    R.ifElse(R.isTrue, () => {
      form.current.clear();
      clearForm();
    }, () => {
      R.when(R.complement(R.equals(state.schema)), () => {
        clearForm();
      })(schema);
    })(isExtraDataChanged);
  }, [formData, schema, extraData]);
  const actionButtonsRef = React.useRef(null);
  const onChangeCallback = React.useCallback(({
    formData: newData
  }) => {
    var _actionButtonsRef$cur;

    (_actionButtonsRef$cur = actionButtonsRef.current) === null || _actionButtonsRef$cur === void 0 ? void 0 : _actionButtonsRef$cur.onChange(newData, form.current);
    onChange === null || onChange === void 0 ? void 0 : onChange(newData, form.current);
  }, [actionButtonsRef.current, extraData]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    // <Card
    //   style={{ margin: 5, padding :0 }}
    // >
    React.createElement(FormNative, _extends({
      ref: form,
      key: state.key,
      schema: state.schema,
      uiSchema: state.uiSchema
    }, Templates, {
      // @ts-ignore
      fields: _objectSpread(_objectSpread({}, fields), Fields),
      widgets: _objectSpread(_objectSpread({}, widgets), Widgets) // @ts-ignore
      ,
      ErrorList: ErrorList,
      tagName: props => /*#__PURE__*/React.createElement(MockHTMLForm, props, /*#__PURE__*/React.createElement(Container, null, props.children)),
      formContext: formContext,
      formData: formData,
      onChange: onChangeCallback
    }, directProps), children !== null && children !== void 0 ? children : /*#__PURE__*/React.createElement(ActionButtons, {
      key: state.key,
      formData: formData,
      ref: actionButtonsRef,
      formContext: formContext,
      defaultSubmitEnabled: !!defaultSubmitEnabled,
      onSubmit: async () => {
        var _form$current, _form$current2, _form$current2$state, _form$current3, _form$current3$state, _form$current4;

        const validation = await ((_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.validate((_form$current2 = form.current) === null || _form$current2 === void 0 ? void 0 : (_form$current2$state = _form$current2.state) === null || _form$current2$state === void 0 ? void 0 : _form$current2$state.formData, (_form$current3 = form.current) === null || _form$current3 === void 0 ? void 0 : (_form$current3$state = _form$current3.state) === null || _form$current3$state === void 0 ? void 0 : _form$current3$state.schema));
        (_form$current4 = form.current) === null || _form$current4 === void 0 ? void 0 : _form$current4.setState(_objectSpread(_objectSpread({}, form.current.state), validation));
        return R.when(R.lengthEq(0), R.pipe(() => {
          var _form$current5;

          return (_form$current5 = form.current) === null || _form$current5 === void 0 ? void 0 : _form$current5.submit();
        }, () => onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(form.current.state.formData, form.current)))(validation.errors);
      },
      onClear: () => form.current.clear()
    })) // </Card>

  );
}

export default wrapComponent(FormElement, {
  isForwardRef: true
});